import { Alert } from 'react-bootstrap';
import BackButton from '../../Components/BackButton';
import AdminBarcodeLookup from '../../Components/admin/AdminBarcodeLookup';

const BarcodeLookupScreen = () => {
  return (
    <>
      <BackButton />
      <h1 className='mb-2'>Barcode Scanner / Lookup</h1>
      <p className='text-muted mb-3'>
        Use this page for warehouse receiving, picking, and stock checks. Scan a barcode or type SKU/part number.
      </p>

      <Alert variant='info' className='mb-3'>
        You can see barcodes and locations in:
        <ul className='mb-0 mt-2'>
          <li>Admin Product List columns</li>
          <li>Admin Product Edit fields</li>
          <li>Scan results below</li>
        </ul>
      </Alert>
      <Alert variant='secondary' className='mb-3'>
        Most USB/Bluetooth barcode scanners work as keyboard input (HID mode). Click the scan input once, then scan.
      </Alert>

      <AdminBarcodeLookup />
    </>
  );
};

export default BarcodeLookupScreen;
